/**
 * @author 韩天尊
 * @time 2024-01-15
 * @version 1.0.0
 * @description 页面头部组件
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
    title: string;
    showBack?: boolean;
    onBack?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, showBack = true, onBack }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    return (
        <div className="page-header">
            {showBack && (
                <button className="back-btn" onClick={handleBack}>
                    <i className="fas fa-arrow-left"></i>
                </button>
            )}
            <h2>{title}</h2>
        </div>
    );
};

export default PageHeader;
